import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

/**
 * CANCEL ACCOUNT DELETION — public page opened from the emailed link
 * /cancel-deletion?token=...
 */
export default function CancelDeletion() {
  const [token, setToken]     = useState('');
  const [error, setError]     = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setToken(params.get('token') || '');
  }, []);

  const handleCancel = async () => {
    setError('');
    setLoading(true);
    try {
      const res = await axios.post('/api/v1/account-deletion/cancel', { token });
      setSuccess(res.data.message);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong. The link may be invalid or expired.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.brand}>
          <div style={styles.logo}>Q</div>
          <div>
            <div style={styles.brandName}>Qlicxo</div>
            <div style={styles.brandTagline}>Digital Marketing Operations</div>
          </div>
        </div>

        <h2 style={styles.title}>Cancel account deletion</h2>

        {!token && <div style={styles.error}>Invalid cancel link. Please use the link from your email.</div>}
        {error   && <div style={styles.error}>{error}</div>}
        {success && <div style={styles.success}>{success}</div>}

        {token && !success && (
          <>
            <p style={{ color: '#9ca3af', fontSize: '14px', lineHeight: 1.6, marginBottom: '20px' }}>
              Your agency account is scheduled for permanent deletion. Click below to stop the deletion and restore the account for your whole team.
            </p>
            <button
              type="button"
              onClick={handleCancel}
              style={loading ? { ...styles.button, opacity: 0.7 } : styles.button}
              disabled={loading}
            >
              {loading ? 'Restoring...' : 'Cancel Deletion & Restore Account'}
            </button>
          </>
        )}

        <div style={styles.backLink}>
          <Link to="/login" style={styles.link}>← {success ? 'Go to login' : 'Back to login'}</Link>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    background: '#0f1117',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
  },
  card: {
    background: '#1a1d27',
    borderRadius: '16px',
    padding: '40px',
    width: '100%',
    maxWidth: '420px',
    border: '1px solid #2a2d3e',
  },
  brand: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginBottom: '32px',
  },
  logo: {
    width: '44px',
    height: '44px',
    background: 'linear-gradient(135deg, #6c58f0, #4f8ef7)',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    fontSize: '20px',
    fontWeight: '700',
  },
  brandName: {
    color: '#fff',
    fontSize: '18px',
    fontWeight: '700',
  },
  brandTagline: {
    color: '#6b7280',
    fontSize: '12px',
  },
  title: {
    color: '#fff',
    fontSize: '22px',
    fontWeight: '600',
    marginBottom: '24px',
  },
  error: {
    background: '#2d1515',
    border: '1px solid #ef4444',
    color: '#ef4444',
    padding: '12px',
    borderRadius: '8px',
    marginBottom: '16px',
    fontSize: '14px',
  },
  success: {
    background: '#0f2d1a',
    border: '1px solid #22c55e',
    color: '#22c55e',
    padding: '12px',
    borderRadius: '8px',
    marginBottom: '16px',
    fontSize: '14px',
    lineHeight: '1.6',
  },
  formGroup: {
    marginBottom: '16px',
  },
  label: {
    display: 'block',
    color: '#9ca3af',
    fontSize: '14px',
    marginBottom: '6px',
  },
  input: {
    width: '100%',
    padding: '12px',
    background: '#0f1117',
    border: '1px solid #2a2d3e',
    borderRadius: '8px',
    color: '#fff',
    fontSize: '14px',
    boxSizing: 'border-box',
    outline: 'none',
  },
  button: {
    width: '100%',
    padding: '12px',
    background: 'linear-gradient(135deg, #6c58f0, #4f8ef7)',
    border: 'none',
    borderRadius: '8px',
    color: '#fff',
    fontSize: '15px',
    fontWeight: '600',
    cursor: 'pointer',
    marginTop: '8px',
  },
  backLink: {
    textAlign: 'center',
    marginTop: '20px',
    fontSize: '14px',
  },
  link: {
    color: '#6c58f0',
    textDecoration: 'none',
    fontWeight: '500',
  },
};
